import { render } from "./BoqMasterList.vue?vue&type=template&id=7b072a9e"
import script from "@/assets/boq/BoqMasterList.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqMasterList.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__